<script setup lang="ts">
interface Props {
  heading: string
  kind?: string
}

const props = withDefaults(defineProps<Props>(), {
  kind: 'plain-centered'
})
</script>

<template>
  <div class="page-header" :class="props.kind">
    <h1>{{ props.heading }}</h1>
    <hr v-if="props.kind == 'left-divider'">
  </div>
</template>

<style scoped lang="scss">
.page-header {
  margin-bottom: 1.75rem;
}

.plain-centered {
  text-align: center;
}
</style>

  